export default {
  reportParams(state, params) {
    return (state.reportParams = params);
  },
  reportTotal(state, value) {
    return (state.reportTotal = value);
  },
  employeeData(state, value) {
    return (state.employeeData = value);
  },
  leaveData(state, value) {
    return (state.leaveData = value);
  },
  tableHeading(state, value) {
    return (state.tableHeading = value);
  },
  branches(state, value) {
    return (state.branches = value);
  },
  departments(state, value) {
    return (state.departments = value);
  },
  employees(state, value) {
    return (state.employees = value);
  },
  leaveTypes(state, value) {
    return (state.leaveTypes = value);
  },
  currentPage(state, value) {
    return (state.currentPage = value);
  },
  perPage(state, value) {
    return (state.perPage = value);
  },
  tableLoading(state, value) {
    return (state.tableLoading = value);
  },
  exemptionData(state, value) {
    return (state.exemptionData = value);
  },
  reportType(state, value) {
    return (state.reportType = value);
  },
  exemptionReportTotal(state, value) {
    return (state.exemptionReportTotal = value);
  },
  currentPageExemption(state, value) {
    return (state.currentPageExemption = value);
  },
  perPageExemption(state, value) {
    return (state.perPageExemption = value);
  },
};
